var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { loading: _vm.loading } },
    [
      _c(
        "div",
        { staticClass: "fixedButton" },
        [
          _c(
            "vxe-button",
            { staticClass: "examineButton", on: { click: _vm.ReturnFun } },
            [_vm._v("返回")]
          ),
          _vm.approveBtnType === "1"
            ? _c(
                "vxe-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: ["signIndex:startApproveBtn"],
                      expression: "['signIndex:startApproveBtn']",
                    },
                  ],
                  staticClass: "examineButton",
                  attrs: { status: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleApprove(0)
                    },
                  },
                },
                [_vm._v("发起审批")]
              )
            : _vm._e(),
          _vm.approveBtnType === "3"
            ? _c(
                "vxe-button",
                {
                  staticClass: "examineButton",
                  attrs: { status: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleApprove(5)
                    },
                  },
                },
                [_vm._v("重新发起审批")]
              )
            : _vm._e(),
          _vm.approveBtnType === "2"
            ? _c(
                "vxe-button",
                {
                  staticClass: "examineButton",
                  attrs: { status: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleApprove(1)
                    },
                  },
                },
                [_vm._v("同意")]
              )
            : _vm._e(),
          _vm.approveBtnType === "2"
            ? _c(
                "vxe-button",
                {
                  staticClass: "examineButton",
                  attrs: { status: "warning" },
                  on: {
                    click: function ($event) {
                      return _vm.handleApprove(2)
                    },
                  },
                },
                [_vm._v("退给上一审批人")]
              )
            : _vm._e(),
          _vm.approveBtnType === "2"
            ? _c(
                "vxe-button",
                {
                  staticClass: "examineButton",
                  attrs: { status: "danger" },
                  on: {
                    click: function ($event) {
                      return _vm.handleApprove(3)
                    },
                  },
                },
                [_vm._v("驳回")]
              )
            : _vm._e(),
          _vm.approveBtnType === "2"
            ? _c(
                "vxe-button",
                {
                  staticClass: "examineButton",
                  attrs: { status: "danger" },
                  on: {
                    click: function ($event) {
                      return _vm.handleApprove(6)
                    },
                  },
                },
                [_vm._v("不同意")]
              )
            : _vm._e(),
          _vm.approveBtnType === "2"
            ? _c(
                "vxe-button",
                {
                  staticClass: "examineButton",
                  on: {
                    click: function ($event) {
                      return _vm.handleApprove(4)
                    },
                  },
                },
                [_vm._v("转派")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "CertificateReleaseApplicationBox scrollBars",
          style: "height:" + (_vm.$store.state.app.height - 80) + "px;",
        },
        [
          _c(
            "el-collapse",
            {
              staticClass: "collapse-box",
              staticStyle: { "margin-bottom": "10px" },
              model: {
                value: _vm.activityInfo,
                callback: function ($$v) {
                  _vm.activityInfo = $$v
                },
                expression: "activityInfo",
              },
            },
            [
              _c(
                "el-collapse-item",
                { staticClass: "collapseItem", attrs: { title: "活动信息" } },
                [
                  _c("ActivityMaintenanceInformation", {
                    attrs: { data: _vm.activity },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("ActivityReportingInformation", {
            attrs: {
              data: _vm.signData,
              activity: _vm.activity,
              "file-list": _vm.fileList,
              approveBtnType: _vm.approveBtnType,
              priceDiff: _vm.priceDiff,
            },
          }),
          _c(
            "el-collapse",
            {
              staticClass: "collapse-box",
              staticStyle: { "margin-bottom": "10px" },
              model: {
                value: _vm.collapseNumber,
                callback: function ($$v) {
                  _vm.collapseNumber = $$v
                },
                expression: "collapseNumber",
              },
            },
            [
              _c(
                "el-collapse-item",
                {
                  staticClass: "collapseItem",
                  attrs: { title: "提报审核历史", name: "default" },
                },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.findHistTasksData,
                        loading: _vm.approveLoading,
                        border: "",
                        stripe: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "displayName", label: "审核部门" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "operatorName", label: "审核人" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "finishTime", label: "审核时间" },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "approveCost",
                          label: "提报审核费用(元)",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                row.approveCost
                                  ? _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("toThousandNumFilter")(
                                              row.approveCost
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "operateType", label: "操作类型" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "approveMsg", label: "审核意见" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "审批信息",
            visible: _vm.dialogVisible,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.approveTypeName === "转 派"
            ? _c(
                "div",
                {
                  staticClass: "demo-input-suffix",
                  staticStyle: { "padding-bottom": "20px" },
                },
                [
                  _vm._v(" 转派人： "),
                  _c("el-input", {
                    staticStyle: { width: "35%" },
                    attrs: { placeholder: "请选择转派的用户" },
                    on: { focus: _vm.chooseUser },
                    model: {
                      value: _vm.operatorUser,
                      callback: function ($$v) {
                        _vm.operatorUser = $$v
                      },
                      expression: "operatorUser",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.approveTypeName === "同 意"
            ? _c(
                "div",
                {
                  staticClass: "demo-input-suffix",
                  staticStyle: { "padding-bottom": "20px" },
                },
                [
                  _vm._v(" 审核金额： "),
                  _c("el-input-number", {
                    attrs: {
                      precision: 2,
                      "controls-position": "right",
                      step: 0.1,
                      min: 0.0,
                      max: 9000000000000,
                      controls: false,
                    },
                    model: {
                      value: _vm.approveCost,
                      callback: function ($$v) {
                        _vm.approveCost = $$v
                      },
                      expression: "approveCost",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c("el-input", {
            attrs: {
              type: "textarea",
              placeholder: "请输入审批意见",
              maxlength: "300",
              "show-word-limit": "",
            },
            on: { input: _vm.gettotalCost },
            model: {
              value: _vm.approveMsg,
              callback: function ($$v) {
                _vm.approveMsg = $$v
              },
              expression: "approveMsg",
            },
          }),
          _vm.approveValFalse
            ? _c("span", { staticStyle: { color: "red" } }, [
                _vm._v("审批意见不能为空"),
              ])
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  attrs: { loading: _vm.approveBtnLoading, status: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.approve()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.approveTypeName))]
              ),
              _c(
                "vxe-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择用户",
            visible: _vm.userDialogVisible,
            width: "75%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.userDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "20px" } },
            [
              _c("el-input", {
                style: { width: "80%" },
                attrs: { placeholder: "输入用户名称", clearable: "" },
                on: { change: _vm.handleFilter },
                model: {
                  value: _vm.userName,
                  callback: function ($$v) {
                    _vm.userName = $$v
                  },
                  expression: "userName",
                },
              }),
              _c(
                "vxe-button",
                {
                  staticClass: "filter-search-item",
                  staticStyle: { float: "right" },
                  attrs: { status: "primary", icon: "el-icon-search" },
                  on: { click: _vm.handleFilter },
                },
                [_vm._v("查询")]
              ),
            ],
            1
          ),
          _c(
            "vxe-table",
            {
              ref: "Xuser",
              attrs: {
                border: "",
                "show-header-overflow": "",
                "show-overflow": "",
                "column-config": { resizable: true },
                stripe: "",
                round: "",
                loading: _vm.userLoading,
                "max-height": "350",
                align: "center",
                "scroll-y": { enabled: false },
                data: _vm.userLists,
                reserve: true,
                "row-config": { isCurrent: true, isHover: true },
                "radio-config": {
                  strict: false,
                  labelField: "seq",
                  trigger: "row",
                  isCurrent: true,
                  isHover: true,
                },
              },
            },
            [
              _c("vxe-column", { attrs: { type: "radio", width: "60" } }),
              _c("vxe-column", {
                attrs: { visible: false, field: "id", title: "用户id" },
              }),
              _c("vxe-column", {
                attrs: { type: "seq", title: "序号", width: "60" },
              }),
              _c("vxe-column", {
                attrs: { field: "name", title: "用户名称", width: "110" },
              }),
              _c("vxe-column", {
                attrs: { field: "department", title: "所属组织结构" },
              }),
            ],
            1
          ),
          _c("vxe-pager", {
            attrs: {
              loading: _vm.userLoading,
              "current-page": _vm.addTablePage.currentPage,
              "page-size": _vm.addTablePage.pageSize,
              total: _vm.addTablePage.totalResult,
              layouts: [
                "PrevPage",
                "JumpNumber",
                "NextPage",
                "FullJump",
                "Sizes",
                "Total",
              ],
            },
            on: { "page-change": _vm.handlePageChange },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.userDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "vxe-button",
                {
                  attrs: { status: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleChooseUser()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }